"use strict";
/* tslint:disable */
/* eslint-disable */
/*
Carbon

Connect external data to LLMs, no matter the source.

The version of the OpenAPI document: 1.0.0


NOTE: This file is auto generated by Konfig (https://konfigthis.com).
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersApiGenerated = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
const FormData = require("form-data");
// @ts-ignore
const base_1 = require("../base");
const requestBeforeHook_1 = require("../requestBeforeHook");
/**
 * UsersApi - axios parameter creator
 * @export
 */
const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete Users
         * @param {DeleteUsersInput} deleteUsersInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: (deleteUsersInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteUsersInput' is not null or undefined
            (0, common_1.assertParamExists)('delete', 'deleteUsersInput', deleteUsersInput);
            const localVarPath = `/delete_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: deleteUsersInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/delete_users',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteUsersInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User Endpoint
         * @param {UserRequestContent} userRequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (userRequestContent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userRequestContent' is not null or undefined
            (0, common_1.assertParamExists)('get', 'userRequestContent', userRequestContent);
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: userRequestContent,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/user',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userRequestContent, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List users within an organization
         * @summary List Users Endpoint
         * @param {ListUsersRequest} listUsersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: (listUsersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listUsersRequest' is not null or undefined
            (0, common_1.assertParamExists)('list', 'listUsersRequest', listUsersRequest);
            const localVarPath = `/list_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: listUsersRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/list_users',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(listUsersRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Toggle User Features
         * @param {ModifyUserConfigurationInput} modifyUserConfigurationInput
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        toggleUserFeatures: (modifyUserConfigurationInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'modifyUserConfigurationInput' is not null or undefined
            (0, common_1.assertParamExists)('toggleUserFeatures', 'modifyUserConfigurationInput', modifyUserConfigurationInput);
            const localVarPath = `/modify_user_configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: modifyUserConfigurationInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/modify_user_configuration',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modifyUserConfigurationInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Users
         * @param {UpdateUsersInput} updateUsersInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsers: (updateUsersInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateUsersInput' is not null or undefined
            (0, common_1.assertParamExists)('updateUsers', 'updateUsersInput', updateUsersInput);
            const localVarPath = `/update_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: updateUsersInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/update_users',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUsersInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Me Endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/whoami`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/whoami',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UsersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete Users
         * @param {UsersApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const deleteUsersInput = {
                    customer_ids: requestParameters.customer_ids
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.delete(deleteUsersInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User Endpoint
         * @param {UsersApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const userRequestContent = {
                    customer_id: requestParameters.customer_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(userRequestContent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List users within an organization
         * @summary List Users Endpoint
         * @param {UsersApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const listUsersRequest = {
                    pagination: requestParameters.pagination,
                    filters: requestParameters.filters,
                    order_by: requestParameters.order_by,
                    order_dir: requestParameters.order_dir,
                    include_count: requestParameters.include_count
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.list(listUsersRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Toggle User Features
         * @param {UsersApiToggleUserFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        toggleUserFeatures(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const modifyUserConfigurationInput = {
                    configuration_key_name: requestParameters.configuration_key_name,
                    value: requestParameters.value
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleUserFeatures(modifyUserConfigurationInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Users
         * @param {UsersApiUpdateUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsers(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const updateUsersInput = {
                    auto_sync_enabled_sources: requestParameters.auto_sync_enabled_sources,
                    max_files: requestParameters.max_files,
                    max_files_per_upload: requestParameters.max_files_per_upload,
                    max_characters: requestParameters.max_characters,
                    max_characters_per_file: requestParameters.max_characters_per_file,
                    max_characters_per_upload: requestParameters.max_characters_per_upload,
                    customer_ids: requestParameters.customer_ids
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUsers(updateUsersInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Me Endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.whoAmI(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UsersApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete Users
         * @param {UsersApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete(requestParameters, options) {
            return localVarFp.delete(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User Endpoint
         * @param {UsersApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters, options) {
            return localVarFp.get(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * List users within an organization
         * @summary List Users Endpoint
         * @param {UsersApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters, options) {
            return localVarFp.list(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Toggle User Features
         * @param {UsersApiToggleUserFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        toggleUserFeatures(requestParameters, options) {
            return localVarFp.toggleUserFeatures(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Users
         * @param {UsersApiUpdateUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsers(requestParameters, options) {
            return localVarFp.updateUsers(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Me Endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI(options) {
            return localVarFp.whoAmI(options).then((request) => request(axios, basePath));
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApiGenerated - object-oriented interface
 * @export
 * @class UsersApiGenerated
 * @extends {BaseAPI}
 */
class UsersApiGenerated extends base_1.BaseAPI {
    /**
     *
     * @summary Delete Users
     * @param {UsersApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    delete(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.configuration).delete(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User Endpoint
     * @param {UsersApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    get(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.configuration).get(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List users within an organization
     * @summary List Users Endpoint
     * @param {UsersApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    list(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.configuration).list(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Toggle User Features
     * @param {UsersApiToggleUserFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    toggleUserFeatures(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.configuration).toggleUserFeatures(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Users
     * @param {UsersApiUpdateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    updateUsers(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.configuration).updateUsers(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Me Endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiGenerated
     */
    whoAmI(options) {
        return (0, exports.UsersApiFp)(this.configuration).whoAmI(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UsersApiGenerated = UsersApiGenerated;
